import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        about: "About",
        services: "Services",
        rental: "Rental",
        otherServices: "Other Services",
        gallery: "Gallery",
        contact: "Contact",
        getQuote: "Get a Quote",
        other: "Other",
        featuredEquipment: "Featured Equipment",
        otherEquipment: "Other Equipment",
        moreEquipment: "More Equipment",
        contracting: "Contracting",
        noOtherEquipment: "No additional equipment.",
        logoSubtitle: "Ragime Trading & Contracting WLL",
      },
      common: {
        learnMore: "Learn More",
        viewAll: "View All",
        viewDetails: "View Details",
        readMore: "Read More",
        backToServices: "Services",
        explore: "Explore",
        sendMessage: "Send Message",
        sending: "Sending",
        urgentCall: "Urgent project? Call us now.",
        startProject: "Start a Project",
        requestQuote: "Request a Quote",
        viewFleet: "View Full Fleet",
        viewFullCatalog: "View Full Rental Catalog",
        learnMoreAbout: "Learn More",
        workWithUs: "Work With Us",
        scopeOfWork: "Scope of Work",
        whatsIncluded: "What's Included.",
        otherServices: "Other Services",
        all: "All",
        noResults: "No items in this category yet.",
        close: "Close",
        loading: "Loading...",
        established: "Est.",
        crNumber: "CR No.",
        en: "EN",
        ar: "AR",
      },
      home: {
        eyebrow: "Est. 2025 · Doha · Qatar",
        title1: "Built On",
        title2: "Reliability.",
        title3: "Engineered To",
        title4: "Outlast.",
        ctaServices: "Explore Services",
        ctaContact: "Request a Quote",
        servicesEyebrow: "What We Do",
        servicesTitle: "Equipment That Moves. Crews That Deliver.",
        servicesSubtitle: "From the moment our machines roll onto your site, you get reliability — every meter, every layer, every shift.",
        whyEyebrow: "Why Choose RTC",
        whyTitle: "A Standard, Not a Service.",
        whySubtitle: "We treat every project — from a single excavator rental to a full road build — with the same uncompromising standards.",
        fleetEyebrow: "Fleet",
        fleetTitle: "Machines, Ready to Deploy.",
        fleetSubtitle: "A modern, well-maintained fleet — operated by experienced crews who know Qatar's sites inside out.",
        ctaBannerTitle: "Got A Site? We Bring The Iron.",
        ctaBannerText: "Tell us about your project. We'll get back to you with the right equipment, the right crew, and the right price.",
        featured: "Featured",
        rentalLabel: "Heavy Equipment Rental",
        rentalDesc: "Excavators, loaders, dump trucks, rollers, graders & bulldozers — well-maintained, ready when you are.",
        browseFleet: "Browse Fleet",
        projectsEyebrow: "Our Projects",
        projectsTitle: "Work On The Ground.",
        projectsSubtitle: "A snapshot of recent projects delivered across Doha — excavation, demolition, road works and interlock.",
        clientsEyebrow: "Trusted By",
        clientsTitle: "Our Clients.",
        clientsSubtitle: "A growing network of contractors, developers and infrastructure partners across Qatar.",
        marqueeExcavation: "EXCAVATION",
        marqueeDemolition: "DEMOLITION",
        marqueeInterlock: "INTERLOCK & KERBSTONE",
        marqueeRental: "EQUIPMENT RENTAL",
        marqueeRoadWorks: "ROAD WORKS",
        marqueeDoha: "DOHA · QATAR",
        heavyEquipment: "Heavy Equipment",
      },
      about: {
        eyebrow: "About · The Company",
        title: "We Build Trust First.",
        intro: "RTC (Ragime Trading & Contracting WLL) was established in 2025 with a single, clear ambition — to be the most reliable partner for heavy equipment rental, road works, and construction contracting in Qatar.",
        storyEyebrow: "Our Story",
        storyTitle: "From Day One — Quality, Driven.",
        para1: "RTC Company, established in 2025, has quickly grown into a trusted name in the field of road and construction works. Within a short span of time, we have achieved remarkable success by delivering quality-driven services and earning one of the best reputations in the market.",
        para2: "Our clients are at the heart of our growth. By understanding their needs, we provide them with well-maintained equipment, skilled and experienced operators, and reliable supplies to ensure their projects are completed efficiently and to the highest standards.",
        para3: "With a strong commitment to excellence, innovation, and customer satisfaction, RTC Company continues to build lasting relationships while contributing to the development of infrastructure and construction across the region.",
        missionLabel: "Our Mission",
        missionTitle: "Build, with Purpose.",
        visionLabel: "Our Vision",
        visionTitle: "Trusted, Always.",
        valuesEyebrow: "Core Values",
        valuesTitle: "What We Stand On.",
        valuesSubtitle: "Our values define how we show up on every site, every shift — reliability, safety, quality, and integrity are not aspirations; they are our operating standard.",
        teamEyebrow: "The Team",
        teamTitle: "Skilled Operators. Sharp Crews.",
        teamSubtitle: "Behind every machine is a trained operator who knows the job, knows the site, and knows what quality looks like. Our people are our greatest asset.",
        teamCaption: "The RTC team — ready on every site",
      },
      services: {
        eyebrow: "Services · Rental & Contracting",
        title1: "Heavy Equipment",
        title2: "& Contracting",
        title3: "Services.",
        intro: "Two divisions, one standard. Rent the equipment, contract the work — or both. We handle the heavy lifting so your project stays on schedule.",
        division1Label: "Division 01 · Rental",
        division1Title: "Heavy Equipment Rental.",
        division1Subtitle: "A modern fleet of excavators, loaders, dump trucks, rollers, graders and bulldozers — maintained, operated and ready to deploy across Qatar.",
        division2Label: "Division 02 · Contracting",
        division2Title: "Other Services.",
        division2Subtitle: "From excavation to demolition and interlock work — delivered to spec.",
        ctaTitle: "Tell us your scope.",
        ctaSubtitle: "Equipment rental, full contracting, or a custom mix — we'll scope the right combination for your project.",
      },
      rental: {
        eyebrow: "Heavy Equipment Rental",
        title: "Heavy Equipment Rental.",
        subtitle: "From daily mobilisation to long-term contracts — rent a single machine or a full fleet. All units come maintained, fueled and ready, with experienced operators on demand.",
        feat1: "Well-maintained, modern fleet",
        feat2: "Skilled & licensed operators",
        feat3: "Daily / weekly / monthly terms",
        feat4: "On-site mobilisation across Qatar",
        feat5: "Routine servicing & uptime support",
        feat6: "Transparent rate cards",
        fleetTitle: "Choose Your Machine.",
        fleetSubtitle: "Built tough. Maintained obsessively. Ready when you call.",
        urgentTitle: "Need it on site",
        urgentTitle2: "tomorrow?",
        urgentSubtitle: "Call our dispatch line. We'll confirm availability and mobilise quickly across Doha and surrounds.",
        sendInquiry: "Send Inquiry",
      },
      gallery: {
        eyebrow: "Project Gallery",
        title: "Equipment & Projects.",
        subtitle: "A look at our rental fleet, excavation, demolition, interlock paving and project sites delivered across Qatar.",
        filters: {
          all: "All Works",
          rental: "Equipment",
          excavation: "Excavation",
          demolition: "Demolition",
          interlock: "Interlock",
          projects: "Projects",
        },
      },
      contact: {
        eyebrow: "Get In Touch",
        title1: "Let's Build",
        title2: "Together.",
        intro: "Tell us about your project. The more detail, the faster and tighter our quote.",
        formEyebrow: "Inquiry Form",
        formTitle: "Project Details.",
        formSubtitle: "We typically respond within one business day.",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone",
        serviceNeeded: "Service Needed",
        projectDetails: "Project Details",
        placeholderProject: "Site location, timeline, scope, equipment needed...",
        consent: "By submitting, you agree to be contacted by RTC.",
        successMsg: "Message sent. Our team will reach out shortly.",
        errorMsg: "Could not send your message. Please try again or call us directly.",
        infoEyebrow: "Reach Us",
        infoTitle: "Talk To Our Team.",
        infoSubtitle: "Prefer the phone? Call our dispatch line for instant availability and rates.",
        address: "Address",
        phoneLabel: "Phone",
        emailLabel: "Email",
      },
      footer: {
        navigate: "Navigate",
        services: "Services",
        reach: "Reach Us",
        rights: "All rights reserved.",
        builtWith: "Built with precision · Doha, Qatar",
        about: "Heavy equipment rental and road & construction contracting in Qatar. Reliable machinery, skilled operators, results that hold up.",
      },
      admin: {
        login: "Sign In",
        loginTitle: "Admin Sign In",
        loginSubtitle: "Authorized personnel only.",
        email: "Email",
        password: "Password",
        signIn: "Sign In",
        signingIn: "Signing in",
        invalidCreds: "Invalid email or password",
        dashboard: "Dashboard",
        inquiries: "Inquiries",
        servicesAdmin: "Services & Equipment",
        galleryAdmin: "Gallery",
        contentAdmin: "Site Content",
        logout: "Logout",
        backToSite: "Back to site",
      },
    },
  },
  ar: {
    translation: {
      nav: {
        home: "الرئيسية",
        about: "من نحن",
        services: "خدماتنا",
        rental: "تأجير",
        otherServices: "خدمات أخرى",
        gallery: "المعرض",
        contact: "تواصل",
        getQuote: "اطلب عرض سعر",
        other: "أخرى",
        featuredEquipment: "معدات مميزة",
        otherEquipment: "معدات أخرى",
        moreEquipment: "المزيد من المعدات",
        contracting: "مقاولات",
        noOtherEquipment: "لا توجد معدات إضافية.",
        logoSubtitle: "راجيمي للتجارة والمقاولات ذ.م.م",
      },
      common: {
        learnMore: "اعرف المزيد",
        viewAll: "عرض الكل",
        viewDetails: "عرض التفاصيل",
        readMore: "اقرأ المزيد",
        backToServices: "الخدمات",
        explore: "استكشف",
        sendMessage: "إرسال الرسالة",
        sending: "جارٍ الإرسال",
        urgentCall: "مشروع عاجل؟ اتصل بنا الآن.",
        startProject: "ابدأ مشروعًا",
        requestQuote: "اطلب عرض سعر",
        viewFleet: "عرض الأسطول",
        viewFullCatalog: "عرض كتالوج التأجير الكامل",
        learnMoreAbout: "اعرف المزيد",
        workWithUs: "اعمل معنا",
        scopeOfWork: "نطاق العمل",
        whatsIncluded: "ما يتضمنه العمل.",
        otherServices: "خدمات أخرى",
        all: "الكل",
        noResults: "لا توجد عناصر في هذه الفئة بعد.",
        close: "إغلاق",
        loading: "جارٍ التحميل...",
        established: "تأسست",
        crNumber: "س.ت",
        en: "EN",
        ar: "AR",
      },
      home: {
        eyebrow: "تأسست 2025 · الدوحة · قطر",
        title1: "بُنيت على",
        title2: "الموثوقية.",
        title3: "مهندسة",
        title4: "لتدوم.",
        ctaServices: "استكشف الخدمات",
        ctaContact: "اطلب عرض سعر",
        servicesEyebrow: "ماذا نقدم",
        servicesTitle: "معدات تتحرك. طواقم تنجز.",
        servicesSubtitle: "من اللحظة التي تصل فيها معداتنا إلى موقعك، تحصل على الموثوقية — في كل متر، كل طبقة، كل وردية.",
        whyEyebrow: "لماذا تختار RTC",
        whyTitle: "معيار، وليس مجرد خدمة.",
        whySubtitle: "نتعامل مع كل مشروع — من تأجير حفارة واحدة إلى بناء طريق كامل — بنفس المعايير الصارمة.",
        fleetEyebrow: "الأسطول",
        fleetTitle: "معدات جاهزة للنشر.",
        fleetSubtitle: "أسطول حديث ومُصان جيدًا — يديره طواقم ذوو خبرة يعرفون مواقع قطر عن ظهر قلب.",
        ctaBannerTitle: "لديك موقع؟ نحضر المعدات.",
        ctaBannerText: "أخبرنا عن مشروعك. سنعود إليك بالمعدات الصحيحة والطاقم الصحيح والسعر المناسب.",
        featured: "مميز",
        rentalLabel: "تأجير معدات ثقيلة",
        rentalDesc: "حفارات، لوادر، شاحنات قلابة، مدحلات، ممهدات وجرافات — مُصانة جيدًا، جاهزة عند الطلب.",
        browseFleet: "تصفح الأسطول",
        projectsEyebrow: "مشاريعنا",
        projectsTitle: "العمل على أرض الواقع.",
        projectsSubtitle: "لمحة عن المشاريع الأخيرة المُنجزة في جميع أنحاء الدوحة — الحفر والهدم وأعمال الطرق والإنترلوك.",
        clientsEyebrow: "موثوق به من قبل",
        clientsTitle: "عملاؤنا.",
        clientsSubtitle: "شبكة متنامية من المقاولين والمطورين وشركاء البنية التحتية في جميع أنحاء قطر.",
        marqueeExcavation: "أعمال الحفر",
        marqueeDemolition: "أعمال الهدم",
        marqueeInterlock: "الإنترلوك والحجر",
        marqueeRental: "تأجير المعدات",
        marqueeRoadWorks: "أعمال الطرق",
        marqueeDoha: "الدوحة · قطر",
        heavyEquipment: "معدات ثقيلة",
      },
      about: {
        eyebrow: "من نحن · الشركة",
        title: "نبني الثقة أولاً.",
        intro: "تأسست شركة RTC (راجيمي للتجارة والمقاولات) عام 2025 بطموح واضح وحيد — أن تكون الشريك الأكثر موثوقية في تأجير المعدات الثقيلة وأعمال الطرق والمقاولات الإنشائية في قطر.",
        storyEyebrow: "قصتنا",
        storyTitle: "من اليوم الأول — جودة، مدفوعة بالهدف.",
        para1: "تأسست شركة RTC عام 2025، ونمت بسرعة لتصبح اسماً موثوقاً في مجال أعمال الطرق والإنشاءات. وفي غضون فترة قصيرة، حققنا نجاحاً ملحوظاً من خلال تقديم خدمات مدفوعة بالجودة وكسب واحدة من أفضل السمعات في السوق.",
        para2: "عملاؤنا هم محور نمونا. ومن خلال فهم احتياجاتهم، نزودهم بمعدات مُصانة جيداً ومشغلين مهرة وذوي خبرة وإمدادات موثوقة لضمان إنجاز مشاريعهم بكفاءة ووفق أعلى المعايير.",
        para3: "مع التزام راسخ بالتميز والابتكار ورضا العملاء، تواصل شركة RTC بناء علاقات دائمة مع المساهمة في تطوير البنية التحتية والإنشاءات في جميع أنحاء المنطقة.",
        missionLabel: "رسالتنا",
        missionTitle: "نبني، بهدف.",
        visionLabel: "رؤيتنا",
        visionTitle: "موثوقون، دائماً.",
        valuesEyebrow: "قيمنا الأساسية",
        valuesTitle: "ما نقف عليه.",
        valuesSubtitle: "قيمنا تحدد كيفية حضورنا في كل موقع وكل وردية — الموثوقية والسلامة والجودة والنزاهة ليست تطلعات، بل هي معيارنا التشغيلي.",
        teamEyebrow: "فريقنا",
        teamTitle: "مشغلون مهرة. طواقم محترفة.",
        teamSubtitle: "خلف كل آلة مشغل مدرب يعرف العمل ويعرف الموقع ويعرف معنى الجودة. موظفونا هم أعظم أصولنا.",
        teamCaption: "فريق RTC — جاهز في كل موقع",
      },
      services: {
        eyebrow: "الخدمات · تأجير ومقاولات",
        title1: "حديد، أسفلت",
        title2: "وكل شيء",
        title3: "بينهما.",
        intro: "قسمان، معيار واحد. استأجر المعدات، أو تعاقد على العمل — أو كليهما. نتولى المهام الثقيلة لإبقاء مشروعك في الموعد.",
        division1Label: "القسم 01 · التأجير",
        division1Title: "تأجير المعدات الثقيلة.",
        division1Subtitle: "أسطول حديث من الحفارات واللوادر والشاحنات القلابة والمدحلات والممهدات والجرافات — مُصانة، يديرها مشغلون، وجاهزة للنشر في جميع أنحاء قطر.",
        division2Label: "القسم 02 · المقاولات",
        division2Title: "خدمات أخرى.",
        division2Subtitle: "من الأساس فصاعدًا — أعمال الحفر والأسفلت والهدم والإنترلوك تُنجز وفق المواصفات.",
        ctaTitle: "أخبرنا بنطاق عملك.",
        ctaSubtitle: "تأجير معدات أو مقاولات كاملة أو مزيج مخصص — سنحدد التركيبة المناسبة لمشروعك.",
      },
      rental: {
        eyebrow: "تأجير المعدات الثقيلة",
        title: "تأجير المعدات الثقيلة.",
        subtitle: "من النشر اليومي إلى العقود طويلة الأمد — استأجر آلة واحدة أو أسطولاً كاملاً. جميع الوحدات تأتي مُصانة ومزودة بالوقود وجاهزة، مع مشغلين ذوي خبرة عند الطلب.",
        feat1: "أسطول حديث ومُصان جيدًا",
        feat2: "مشغلون مهرة ومرخصون",
        feat3: "شروط يومية / أسبوعية / شهرية",
        feat4: "نشر في الموقع في جميع أنحاء قطر",
        feat5: "صيانة دورية ودعم استمرارية التشغيل",
        feat6: "بطاقات أسعار شفافة",
        fleetTitle: "اختر آلتك.",
        fleetSubtitle: "مبنية لتدوم. صيانة هاجسية. جاهزة عند الاتصال.",
        urgentTitle: "تحتاجها في الموقع",
        urgentTitle2: "غدًا؟",
        urgentSubtitle: "اتصل بخط التوزيع لدينا. سنؤكد التوفر وننشر بسرعة في الدوحة والمناطق المحيطة.",
        sendInquiry: "إرسال استفسار",
      },
      gallery: {
        eyebrow: "معرض المشاريع",
        title: "المعدات والمشاريع.",
        subtitle: "نظرة على أسطول المعدات وأعمال الحفر والهدم ورصف الإنترلوك ومواقع المشاريع المُنجزة في جميع أنحاء قطر.",
        filters: {
          all: "جميع الأعمال",
          rental: "المعدات",
          excavation: "حفر",
          demolition: "هدم",
          interlock: "إنترلوك",
          projects: "مشاريع",
        },
      },
      contact: {
        eyebrow: "تواصل معنا",
        title1: "لنبني",
        title2: "معًا.",
        intro: "أخبرنا عن مشروعك. كلما زادت التفاصيل، كان عرضنا أسرع وأدق.",
        formEyebrow: "نموذج الاستفسار",
        formTitle: "تفاصيل المشروع.",
        formSubtitle: "عادةً ما نرد خلال يوم عمل واحد.",
        fullName: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        serviceNeeded: "الخدمة المطلوبة",
        projectDetails: "تفاصيل المشروع",
        placeholderProject: "موقع العمل، الجدول الزمني، النطاق، المعدات المطلوبة...",
        consent: "بالإرسال، فإنك توافق على أن تتواصل معك RTC.",
        successMsg: "تم إرسال الرسالة. سيتواصل فريقنا معك قريبًا.",
        errorMsg: "تعذر إرسال رسالتك. يرجى المحاولة مرة أخرى أو الاتصال بنا مباشرة.",
        infoEyebrow: "للوصول إلينا",
        infoTitle: "تحدث إلى فريقنا.",
        infoSubtitle: "تفضل الاتصال؟ اتصل بخط التوزيع لدينا للحصول على التوفر والأسعار الفورية.",
        address: "العنوان",
        phoneLabel: "الهاتف",
        emailLabel: "البريد الإلكتروني",
      },
      footer: {
        navigate: "تصفح",
        services: "الخدمات",
        reach: "للوصول إلينا",
        rights: "جميع الحقوق محفوظة.",
        builtWith: "صُنع بدقة · الدوحة، قطر",
        about: "تأجير معدات ثقيلة وأعمال طرق وإنشاءات في قطر. آلات موثوقة، مشغلون مهرة، نتائج تدوم.",
      },
      admin: {
        login: "تسجيل الدخول",
        loginTitle: "تسجيل دخول المسؤول",
        loginSubtitle: "للموظفين المعتمدين فقط.",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        signIn: "دخول",
        signingIn: "جارٍ تسجيل الدخول",
        invalidCreds: "بريد إلكتروني أو كلمة مرور غير صالحة",
        dashboard: "لوحة التحكم",
        inquiries: "الاستفسارات",
        servicesAdmin: "الخدمات والمعدات",
        galleryAdmin: "المعرض",
        contentAdmin: "محتوى الموقع",
        logout: "تسجيل الخروج",
        backToSite: "العودة إلى الموقع",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "rtc_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
